export const fadeInUp: any = {
  hidden: { opacity: 0.4, y: 90 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.9 } },
};

export const containerVariants = {
  hidden: {
    transition: {
      staggerChildren: 0.05,
      staggerDirection: -1,
    },
  },
  show: {
    transition: {
      staggerChildren: 0.05,
      staggerDirection: 1,
    },
  },
};

export const itemVariants: any = {
  hidden: { opacity: 0, x: 40 },
  show: { opacity: 1, x: 0, transition: { duration: 0.4, ease: "easeOut" } },
};

export const MODAL_ANIMATION: any = {
  secondary: { color: "#FFFFFF" },
  default: { color: "#A2A2A2" },
};

export const MODAL_ANIMATION_TIMING: any = {
  show: { duration: 50 },
  default: { duration: 100 },
};

export const DRAWER_BACKGROUND_RGB = {
  XS: "rgba(18, 18, 18, 0.80)",
  SM: "rgba(18, 18, 18, 0.80)",
};

export const DEFAULT_BUTTON_COLOR = "#000";
